<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 400px;">
        <el-form :model="addForm" ref="addForm" :rules="rules">
          <el-row>

            <el-col :span="12" class="item" >
              <el-form-item label="胆固醇" prop="value">
                <el-input placeholder="请输入胆固醇" v-model="addForm.value"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="检查时间"  prop="time">
                <el-date-picker
                    v-model="addForm.time"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="选择检查时间">
                </el-date-picker>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {

      loading: false,

      addForm: {
        timeStr: timeStr,
        staffCode: getStaffCode(),
        sign: "",
        userCode: "",

        valueType:6,
        value:'',
        time:'',

      },

      rules: {
        value: [
          { required: true, message: "请输入胆固醇", trigger: "blur" },
        ],
        time:[
          { required: true, message: "请选择检查时间", trigger: "blur" },
        ],


      },

    };
  },
  created() {},
  components: {},
  watch: {
    //监听全局变量
    "$store.state.tableHeight": function () {},
  },
  methods: {

    init(userCode) {
      this.$refs.addForm.resetFields();
      this.addForm.userCode = userCode;
      this.addForm.value = '';
      this.addForm.time = timefilters(new Date()).slice(0,10);
    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSubmit() {

      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey);

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DataAll/WriteAdd",
        data: this.addForm,
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("resultSuccess");
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>

</style>
